import api from 'service/api'
// Import direto do leaf: o barrel de helpers puxa o grafo inteiro da aplicação,
// que ainda não está inicializado quando os módulos de service são avaliados.
import buildAnswerFormData from 'helpers/privacyByDesign/buildAnswerFormData'

const dponetAPI = api.create('dponet')

const get = async ({ privacyByDesignId = '', ...params }) => {
  return await dponetAPI.get(`/privacy_by_designs/${privacyByDesignId}`, {
    params,
  })
}

const create = async (data) => {
  return await dponetAPI.postForm('/privacy_by_designs', {
    privacyByDesign: data,
  })
}

const update = async ({ privacyByDesignId = '', ...params }) => {
  return await dponetAPI.put(`/privacy_by_designs/${privacyByDesignId}`, {
    privacyByDesign: params,
  })
}

const changeStatus = async ({ privacyByDesignId = '', ...params }) => {
  return await dponetAPI.putForm(
    `/privacy_by_designs/${privacyByDesignId}/change_status`,
    {
      privacyByDesign: params,
    },
  )
}

const softDelete = async ({ privacyByDesignId = '' }) => {
  return await dponetAPI.put(`/privacy_by_designs/${privacyByDesignId}`)
}

const listQuizTemplates = async (params) => {
  return await dponetAPI.get('/privacy_by_designs/quiz_templates', { params })
}

const getUsers = async (params) => {
  return await dponetAPI.get('/privacy_by_designs/available_users', { params })
}

const getDepartments = async (params) => {
  return await dponetAPI.get('/privacy_by_designs/available_departments', {
    params,
  })
}

const report = async (params = {}) => {
  return await dponetAPI.post('/privacy_by_designs/report', {
    privacyByDesignReport: params,
  })
}

const replyAnswer = async ({ privacyByDesignId, answerId, ...answerData }) => {
  return await dponetAPI.put(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/reply`,
    buildAnswerFormData(answerData),
  )
}

const reopenAnswer = async ({ privacyByDesignId, answerId }) => {
  return await dponetAPI.put(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/reopen`,
  )
}

const destroyAnswerEvidence = async ({
  privacyByDesignId,
  answerId,
  evidenceId,
}) => {
  return await dponetAPI.delete(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/evidence?evidence_id=${evidenceId}`,
  )
}

const privacyByDesign = {
  get,
  create,
  update,
  changeStatus,
  softDelete,
  getUsers,
  getDepartments,
  listQuizTemplates,
  report,
  replyAnswer,
  reopenAnswer,
  destroyAnswerEvidence,
}

export default privacyByDesign
